import { render, staticRenderFns } from "./CharacteristicsSummary.vue?vue&type=template&id=39e61c1c&scoped=true"
import script from "./CharacteristicsSummary.vue?vue&type=script&lang=js"
export * from "./CharacteristicsSummary.vue?vue&type=script&lang=js"
import style0 from "./CharacteristicsSummary.vue?vue&type=style&index=0&id=39e61c1c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e61c1c",
  null
  
)

export default component.exports